export const doAll = ( ...expressions ) =>
expressions[expressions.length - 1];
